import { cn } from "@omni/utils/styles";
import { ComponentProps, ReactNode } from "react";

import { Anchor } from "@/components/General/Anchor/anchor.component";

type Props = Omit<ComponentProps<typeof Anchor>, "children"> & {
    children: ReactNode;
};

export const Link = ({ className, href, children, ...props }: Props) => {
    if (!href) return null;

    return (
        <Anchor
            {...props}
            color={"link"}
            className={cn("tw:p-0", className)}
            href={href}
        >
            {children}
        </Anchor>
    );
};
